import { Injectable } from '@angular/core';
import { FleetCardInformationResponse, RegisterFleetCardRequest, RegisterFleetCardResponse, TransferFleetCardRequest } from 'app/model/fleet/fleet.model';
import { environment } from 'environments/environment';
import { FleetCardTransactionHistoryRequest, FleetCardTransactionHistoryResponse } from 'app/model/fleet/fleet-transaction-history-model';
import { Observable } from 'rxjs';
import { ActHttpService, ContentTypes, HeaderTypes } from '../act-http/act-http.service';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable()
export class FleetService {

  constructor(
    private actHttpService: ActHttpService,
    private utilitiesService: UtilitiesService
  ) { }

  getFleetCardInformation(sortBy: string, companyId: number = null, fleetCardType: string = null, status: string = null): Observable<FleetCardInformationResponse[]> {
    let url = `${environment.endpoint.getFleetCardInformation}?sortBy=${sortBy}`;
    if (fleetCardType) {
      url += `&fleetCardType=${fleetCardType}`;
    }
    if (companyId) {
      url += `&companyId=${companyId.toString()}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    const options = this.actHttpService.getRequestOptions();
    return this.actHttpService.get(url, options)
      .map(res => res.json().data);
  }

  getFleetCardTransactionHistory(request: FleetCardTransactionHistoryRequest, fleetCardId: string): Observable<FleetCardTransactionHistoryResponse> {
    const options = this.actHttpService.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    const url = `${environment.endpoint.getTransactionHistory.replace('{fleetCardId}', fleetCardId)}${this.utilitiesService.objectToQueryString(request)}`;
    return this.actHttpService
      .get(url, options)
      .map(response => response.json().data);
  }

  registerFleetCard(fleetCardId: string, secretCode: string, reCaptcha: string): Observable<RegisterFleetCardResponse> {
    const options = this.actHttpService.getRequestOptions();
    const payload: RegisterFleetCardRequest = {
      fleetCardId: fleetCardId,
      secretCode: secretCode,
      reCaptcha: reCaptcha
    };
    const url = environment.endpoint.registerFleetCard;
    return this.actHttpService.post(url, payload, options)
      .map(res => res.json().data);
  }

  transferFleetCard(fleetCardIdFrom: string, fleetCardIdTo: string, amount: number): Observable<any> {
    const options = this.actHttpService.getRequestOptions();
    const payload: TransferFleetCardRequest = {
      from: fleetCardIdFrom,
      to: fleetCardIdTo,
      amount: amount,
    }
    const url = environment.endpoint.transferFleetCard;
    return this.actHttpService.post(url, payload, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/fleet/fleet.service.ts